import React from "react";
import { Row, Col, Button, Typography } from "antd";
const styles = {
  addVideoButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },

  titleContainer: {
    padding: "10px 20px",
    color: "#fb6222",
  },
};
export default function ContantTitle({ heading, openForm, buttonText }) {
  return (
    <Row
      type="flex"
      justify={"space-between"}
      gutter={[16, 16]}
      align={"middle"}
    >
      <Col xs={24} sm={16} md={18}>
        <Typography.Title level={3} style={{ ...styles.titleContainer, margin: 0 }}>
          {heading}
        </Typography.Title>
      </Col>
      {buttonText && (
        <Col xs={24} sm={8} md={6}>
          <div style={styles.addVideoButtonContainer}>
            <Button
              type={"primary"}
              onClick={openForm}
              size="large"
              style={{ ...styles.addVideoButton, width: window.innerWidth < 576 ? '100%' : 'auto' }}
            >
              {buttonText}
            </Button>
          </div>
        </Col>
      )}
    </Row>
  );
}
